export const PARAM_KEY_TO__FILTER = {
  has_foil: 'foil',
  has_custom_photo: 'customphoto',
  has_no_custom_photo: 'nocustomphoto',
  has_magnet: 'magnet',
  is_landscape: 'landscape',
  is_portrait: 'portrait',
  is_vow_renewal: 'elopementandvowrenewal',
  featured_artist: 'featuredArtist',
  is_letterpress: 'is_letterpress',
  single_sample_available: 'multisampleenabled',
};

export const SORT_OPTIONS = [
  { value: 'featured', label: 'Featured' },
  { value: 'launch_date', label: 'Recently Added' },
  { value: 'popularity', label: 'Most Popular' },
];

export const SORT_DEFAULT = SORT_OPTIONS[0].value;

const hostname = typeof window === 'undefined' ? process.env.HOSTNAME : window.location.hostname;

const INVITATION_LINK = `https://${hostname}/wedding-planning/invitations/shop`;
const STD_LINK = `https://${hostname}/wedding-planning/save-the-date/shop`;

export const THEMED_METADATA = {
  INVITATION: {
    summer: {
      title_tag: 'Summer Wedding Invitations - Zola',
      meta: 'Throwing a summer wedding? Create wedding invitations perfect for summer!',
      keywords: 'Summer Wedding Invitations',
      canonical: `${INVITATION_LINK}/summer`,
    },
    fall: {
      title_tag: 'Fall Wedding Invitations - Zola',
      meta:
        'Planning a wedding in Fall? Follow along for how to incorporate Fall into your wedding invitations.',
      keywords: 'Fall Wedding Invitations',
      canonical: `${INVITATION_LINK}/fall`,
    },
    winter: {
      title_tag: 'Winter Wedding Invitations - Zola',
      meta:
        'Having a winter wedding? Follow along to create wedding invitations perfect for winter!',
      keywords: 'Winter Wedding Invitations',
      canonical: `${INVITATION_LINK}/winter`,
    },
    spring: {
      title_tag: 'Spring Wedding Invitations - Zola',
      meta:
        'Looking for spring wedding invitations? Follow along to create your own wedding invitations celebrating spring.',
      keywords: 'Spring Wedding Invitations',
      canonical: `${INVITATION_LINK}/spring`,
    },
    elegant: {
      title_tag: 'Elegant Wedding Invitations - Zola',
      meta:
        'Browse elegant & formal wedding invitations for every budget and style. Get free shipping, guest addressing, envelopes & more!',
      keywords:
        'elegant wedding invitations,fancy wedding invitations,formal elegant wedding invitations,elegant luxury wedding invitations',
      canonical: `${INVITATION_LINK}/elegant`,
    },
    classic: {
      title_tag: 'Traditional & Classic Wedding Invitations - Zola',
      meta:
        'Classic wedding invitations are always in style. Browse traditional invitation designs with free shipping, guest addressing, envelopes, and more!',
      keywords:
        'traditional wedding invitations,classic wedding invitations,classy wedding invitations,classic formal wedding invitations,classic wedding invitation ideas',
      canonical: `${INVITATION_LINK}/classic`,
    },
    floral: {
      title_tag: 'Floral Wedding Invitations - Zola',
      meta:
        'From simple blooms to vibrant flower designs, browse floral wedding invitations for every budget and style. Get free shipping, guest addressing, and more!',
      keywords:
        'floral wedding invitations,flower wedding invitation,floral wedding invitation template,floral themed wedding invitations',
      canonical: `${INVITATION_LINK}/floral`,
    },
    greenery: {
      title_tag: 'Greenery & Botanical Wedding Invitations - Zola',
      meta:
        'Set the tone for your big day with greenery wedding invitations. Browse eucalyptus, botanicals, and more leafy designs. Free shipping & guest addressing.',
      keywords:
        'greenery wedding invitations,eucalyptus wedding invitations,botanical wedding invitations,nature wedding invitations,wedding invitations with greenery',
      canonical: `${INVITATION_LINK}/greenery`,
    },
    rustic: {
      title_tag: 'Rustic & Country Wedding Invitations - Zola',
      meta:
        'Browse rustic & country wedding invitations to set the tone for your big day. Enjoy free shipping, guest addressing, and more!',
      keywords:
        'rustic wedding invitations,country wedding invitations,rustic wedding invitations cheap,rustic country wedding invitations,rustic chic wedding invitations,rustic theme wedding invitation',
      canonical: `${INVITATION_LINK}/rustic`,
    },
    destination: {
      title_tag: 'Destination & Travel Themed Wedding Invitations - Zola',
      meta:
        'Planning a destination wedding? Shop travel-themed wedding invitations & designs. Enjoy free shipping, guest addressing, envelopes, and more!',
      keywords:
        'destination wedding invitations,travel themed wedding invitations,travel wedding invitations,destination themed wedding invitations',
      canonical: `${INVITATION_LINK}/destination`,
    },
    beach: {
      title_tag: 'Beach Themed Wedding Invitations - Zola',
      meta:
        'Browse beach wedding invitations inspired by scenic views and tropical accents. Receive free shipping, guest addressing, and more!',
      keywords:
        'beach wedding invitations,beach themed wedding invitations,tropical wedding invitations,beach wedding invitations with rsvp cards,ocean themed wedding invitations',
      canonical: `${INVITATION_LINK}/beach`,
    },
    bohemian: {
      title_tag: 'Bohemian Wedding Invitations - Zola',
      meta:
        'Inspired by earthy details and romantic charm, browse boho wedding invitations for every budget and style. Get free shipping, guest addressing, and more!',
      keywords:
        'boho wedding invitations,bohemian wedding invitations,boho chic wedding invitations',
      canonical: `${INVITATION_LINK}/bohemian`,
    },
    simple: {
      title_tag: 'Simple & Minimalist Wedding Invitations - Zola',
      meta:
        'Browse simple wedding invitations, perfect for couples who love modern details & minimalist charm. Get free shipping, guest addressing, and more!',
      keywords:
        'simple wedding invitations,minimalist wedding invitations,simple elegant wedding invitations,basic wedding invitations',
      canonical: `${INVITATION_LINK}/simple`,
    },
    modern: {
      title_tag: 'Modern & Contemporary Wedding Invitations - Zola',
      meta:
        'Set the tone for your big day with modern and contemporary wedding invitations. Get free shipping, guest addressing, envelopes, and more!',
      keywords:
        'modern wedding invitations,contemporary wedding invitations,modern unique wedding invitations',
      canonical: `${INVITATION_LINK}/modern`,
    },
    vintage: {
      title_tag: 'Vintage Wedding Invitations - Zola',
      meta:
        'In the market for vintage-style wedding invitations? Follow along to learn about our invitation suites with vintage accents!',
      keywords: 'Vintage Wedding Invitations',
      canonical: `${INVITATION_LINK}/vintage`,
    },
    formal: {
      title_tag: 'Formal Wedding Invitations - Zola',
      meta:
        'Throwing a formal wedding and wondering how to pick proper wedding invitations? Follow along to get started.',
      keywords: 'Formal Wedding Invite',
      canonical: `${INVITATION_LINK}/formal`,
    },
    funny: {
      title_tag: 'Funny Wedding Invitations - Zola',
      meta:
        'Trying to incorporate humor into your invitation? Read below for tips and tricks of funny wedding invitations!',
      keywords: 'Funny Wedding Invitations',
      canonical: `${INVITATION_LINK}/funny`,
    },
    watercolor: {
      title_tag: 'Watercolor Wedding Invitations - Zola',
      meta:
        'Looking for a colorful wedding invitation? Read below why a watercolor wedding invite might be right for you!',
      keywords: 'Watercolor Wedding Invitations',
      canonical: `${INVITATION_LINK}/watercolor`,
    },
    black: {
      title_tag: 'Black Wedding Invitations - Zola',
      meta:
        'Set the tone for your big day with black wedding invitations. Find invitations featuring this elegant and bold color, plus get free shipping, envelopes, and more!',
      keywords:
        'black wedding invitations, black background wedding invitations, black vintage wedding invitations',
      canonical: `${INVITATION_LINK}/black`,
    },
    blue: {
      title_tag: 'Blue Wedding Invitations - Zola',
      meta:
        'Browse blue wedding invitations for every budget and style. Get free shipping, guest addressing, envelopes and more!',
      keywords:
        'blue wedding invitation, Light blue wedding invitations, Tiffany blue wedding invitations',
      canonical: `${INVITATION_LINK}/blue`,
    },
    burgundy: {
      title_tag: 'Burgundy Wedding Invitations - Zola',
      meta:
        'Set the tone for your big day with burgundy wedding invitations. This rich berry hue is perfect for any celebration. Enjoy free shipping and guest addressing!',
      keywords: 'burgundy wedding invitations, burgundy wedding invitation templates',
      canonical: `${INVITATION_LINK}/burgundy`,
    },
    coral: {
      title_tag: 'Coral Wedding Invitations - Zola',
      meta:
        'Browse coral wedding invitations for every budget and style. Get free shipping, guest addressing, envelopes and more!',
      keywords: 'coral wedding invitations, coral color wedding invitations',
      canonical: `${INVITATION_LINK}/coral`,
    },
    dusty_blue: {
      title_tag: 'Dusty Blue Wedding Invitations - Zola',
      meta:
        'Browse dusty blue wedding invitations for every budget and style. Get free shipping, guest addressing, envelopes, and more!',
      keywords: 'dusty blue wedding invitations, Dusty blue wedding invitation sets',
      canonical: `${INVITATION_LINK}/dusty_blue`,
    },
    emerald_green: {
      title_tag: 'Emerald Green Wedding Invitations - Zola',
      meta:
        'Set the tone for your big day with emerald green wedding invitations. This rich jewel tone is perfect for any celebration. Enjoy free shipping and guest addressing!',
      keywords: 'emerald green wedding invitation',
      canonical: `${INVITATION_LINK}/emerald_green`,
    },
    gold: {
      title_tag: 'Gold Wedding Invitations - Zola',
      meta:
        'Set the tone for your big day with gold wedding invitations. Find invitations inspired by this elegant and romantic color. Get free shipping, envelopes, and more!',
      keywords: 'gold wedding invitation, gold foil wedding invitations',
      canonical: `${INVITATION_LINK}/gold`,
    },
    green: {
      title_tag: 'Green Wedding Invitations - Zola',
      meta:
        'Explore green wedding invitations featuring soft, modern, and earthy designs. Shop now with free shipping, guest addressing, and more.',
      keywords: 'green wedding invitation',
      canonical: `${INVITATION_LINK}/green`,
    },
    lavender: {
      title_tag: 'Lavender Wedding Invitations - Zola',
      meta:
        'Love lavender? Shop lavender wedding invitations and envelopes. Get free shipping, guest addressing, envelopes, and more!',
      keywords:
        'lavender wedding invitations, Light purple wedding invitation, lavender flower wedding invitation',
      canonical: `${INVITATION_LINK}/lavender`,
    },
    navy: {
      title_tag: 'Navy Blue Wedding Invitations - Zola',
      meta:
        'Navy blue wedding invitations are always in style. Get free shipping, guest addressing, envelopes, and more.',
      keywords: 'navy blue wedding invitations, navy blue wedding invitation envelopes',
      canonical: `${INVITATION_LINK}/navy`,
    },
    pink: {
      title_tag: 'Pink Wedding Invitations - Zola',
      meta:
        'Shop pink wedding invitations for every budget and style. Get free shipping, guest addressing, envelopes, and more!',
      keywords:
        'pink wedding invitation, dusty pink wedding invitations, pink silver wedding invitations',
      canonical: `${INVITATION_LINK}/pink`,
    },
    plum: {
      title_tag: 'Plum Wedding Invitations - Zola',
      meta:
        'Browse plum wedding invitations for every budget and style. Enjoy free shipping, guest addressing, envelopes, and more.',
      keywords: 'plum wedding invitations, plum colored wedding invitations',
      canonical: `${INVITATION_LINK}/plum`,
    },
    purple: {
      title_tag: 'Purple Wedding Invitations - Zola',
      meta:
        'Purple wedding invitations are always in style. Shop now with free shipping, guest addressing, envelopes, and more.',
      keywords: 'purple wedding invitations, deep purple wedding invitations',
      canonical: `${INVITATION_LINK}/purple`,
    },
    red: {
      title_tag: 'Red Wedding Invitations - Zola,',
      meta:
        'Set the tone for your big day with red wedding invitations. Find invitations inspired by this bold and beautiful color. Get free shipping, envelopes, and more!',
      keywords:
        'red wedding invitation, elegant red wedding invitations, red themed wedding invitations',
      canonical: `${INVITATION_LINK}/red`,
    },
    rose_gold: {
      title_tag: 'Rose Gold Wedding Invitations - Zola',
      meta:
        'Set the tone for your big day with rose gold wedding invitations. Find invitations inspired by this elegant and romantic color. Get free shipping, envelopes, and more!',
      keywords:
        'rose gold wedding invitations, rose gold foil wedding invitations, elegant rose gold wedding invitations, rose gold geometric wedding invitations',
      canonical: `${INVITATION_LINK}/rose_gold`,
    },
    royal_blue: {
      title_tag: 'Royal Blue Wedding Invitations - Zola',
      meta:
        'Set the tone for your big day with royal blue wedding invitations. Find invitations inspired by this classic wedding color. Enjoy free shipping!',
      keywords: 'Royal blue wedding invitation, Royal blue wedding invitation kits',
      canonical: `${INVITATION_LINK}/royal_blue`,
    },
    silver: {
      title_tag: 'Silver Wedding Invitations - Zola',
      meta:
        'Shop silver wedding invitations for every budget and style. Get free shipping, guest addressing, envelopes, and more!',
      keywords: 'silver wedding invitation, silver wedding invitation cards',
      canonical: `${INVITATION_LINK}/silver`,
    },
    teal: {
      title_tag: 'Teal Wedding Invitations - Zola',
      meta:
        'Set the tone for your big day with teal wedding invitations. Shop now with free shipping, envelopes, guest addressing, and more.',
      keywords:
        'teal wedding invitations, rustic teal wedding invitations, dark teal wedding invitations',
      canonical: `${INVITATION_LINK}/teal`,
    },
    white: {
      title_tag: 'White Wedding Invitations - Zola',
      meta:
        'White wedding invitations are always in style. Shop now with free shipping, guest addressing, envelopes, and more.',
      keywords: 'white wedding invitations, pearl white wedding invitations',
      canonical: `${INVITATION_LINK}/white`,
    },
  },
  SAVE_THE_DATE: {
    summer: {
      title_tag: 'Summer Wedding Save the Dates - Zola',
      meta:
        'Inspired by summertime colors and designs, announce your big day with summer save the dates. Shop now with free shipping, guest addressing, and more.',
      keywords: 'summer invitation templates, summer save the dates, summer wedding save the dates',
      canonical: `${STD_LINK}/summer`,
    },
    fall: {
      title_tag: 'Fall Wedding Save the Dates - Zola',
      meta:
        'Announce your wedding day with fall save the dates inspired by the season. Shop now with free shipping, guest addressing, and more.',
      keywords:
        'fall save the dates, fall wedding save the dates, fall themed save the dates, autumn save the dates, fall invitation ideas',
      canonical: `${STD_LINK}/fall`,
    },
    winter: {
      title_tag: 'Winter Wedding Save the Dates - Zola',
      meta:
        'Planning a winter wedding? Announce your big day with winter wedding invitations inspired by the season. Shop now with free shipping.',
      keywords:
        'winter save the dates, winter wedding save the dates, winter wonderland save the dates, winter themed save the dates',
      canonical: `${STD_LINK}/winter`,
    },
    spring: {
      title_tag: 'Spring Wedding Save the Dates - Zola',
      meta:
        'Planning a spring wedding? Shop spring-inspired save the dates to announce your big day. Get free shipping, guest addressing, and more.',
      keywords:
        'spring save the dates, spring wedding save the dates, spring wedding invitation ideas, spring invitation ideas',
      canonical: `${STD_LINK}/spring`,
    },
    elegant: {
      title_tag: 'Elegant Wedding Save the Dates - Zola',
      meta:
        'Browse elegant save the dates for every budget and style. Get free shipping, guest addressing, envelopes and more!',
      keywords: 'elegant save the dates, elegant wedding save the dates',
      canonical: `${STD_LINK}/elegant`,
    },
    classic: {
      title_tag: 'Classic & Traditional Wedding Save the Dates - Zola',
      meta:
        ' Classic save the dates are a timeless way to announce your big day. Shop now with free shipping, guest addressing, and more!',
      keywords:
        'classic save the dates, traditional save the dates, traditional wedding save the dates, classic wedding save the dates',
      canonical: `${STD_LINK}/classic`,
    },
    floral: {
      title_tag: 'Floral Save the Dates - Zola',
      meta:
        'Browse floral save the dates that match any budget and style. Get free shipping, envelopes, and so much more!',
      keywords: 'floral save the dates, floral save the date cards',
      canonical: `${STD_LINK}/floral`,
    },
    greenery: {
      title_tag: 'Greenery Wedding Save the Dates - Zola',
      meta:
        'From eucalyptus to botanicals, choose greenery save the dates to set the tone for your big day. Shop now with free shipping, guest addressing, and more.',
      keywords:
        'eucalyptus save the dates, greenery save the dates, botanical save the dates, nature save the dates, greenery wedding save the dates',
      canonical: `${STD_LINK}/greenery`,
    },
    rustic: {
      title_tag: 'Rustic & Country Wedding Save the Dates - Zola',
      meta:
        'Shop rustic save the dates, perfect for couples inspired by the countryside. Announce your big day with free shipping, guest addressing, and envelopes.',
      keywords:
        'rustic save the dates, rustic wedding save the dates, country save the dates, rustic theme invitation, rustic country save the dates, rustic chic save the dates',
      canonical: `${STD_LINK}/rustic`,
    },
    destination: {
      title_tag: 'Destination Wedding & Travel Save the Dates - Zola',
      meta:
        'Planning a destination wedding? Shop travel-themed save the dates to announce your big day. Get free shipping, guest addressing, and more.',
      keywords:
        'destination wedding save the dates, destination save the dates, travel themed save the dates, travel save the dates',
      canonical: `${STD_LINK}/destination`,
    },
    beach: {
      title_tag: 'Beach Themed Wedding Save the Dates - Zola',
      meta:
        'Planning a wedding by the water? Shop beach themed save the dates to set the tone for your big day. Get free shipping, guest addressing, and envelopes.',
      keywords:
        'beach save the dates, beach themed save the dates, beach wedding save the dates, tropical save the dates, ocean themed save the dates',
      canonical: `${STD_LINK}/beach`,
    },
    bohemian: {
      title_tag: 'Boho Save the Dates - Zola',
      meta:
        'Explore boho save the dates featuring soft, romantic, and earthy designs. Shop now with free shipping, guest addressing, and more.',
      keywords: 'boho save the dates, bohemian save the dates',
      canonical: `${STD_LINK}/bohemian`,
    },
    simple: {
      title_tag: 'Simple & Minimalist Wedding Save the Dates - Zola',
      meta:
        'Shop simple save the dates, ideal for couples who prefer minimalist details and designs. Receive free shipping, guest addressing, and envelopes!',
      keywords:
        'simple save the dates, minimalist save the dates, simple wedding save the dates, basic save the dates, simple elegant save the dates',
      canonical: `${STD_LINK}/simple`,
    },
    modern: {
      title_tag: 'Modern Wedding Save the Dates - Zola',
      meta:
        'Inspired by contemporary designs, modern save the dates set the tone for your big day. Shop now with free shipping!',
      keywords: 'modern save the dates, contemporary save the dates, modern wedding save the dates',
      canonical: `${STD_LINK}/modern`,
    },
    vintage: {
      title_tag: 'Vintage & Retro Save the Dates - Zola',
      meta:
        'Shop vintage save the dates, ideal for couples with old souls and a nostalgic wedding theme. Receive free shipping, guest addressing, and more.',
      keywords:
        'vintage save the dates, retro save the dates, rustic vintage save the dates, vintage style save the dates, vintage wedding save the dates',
      canonical: `${STD_LINK}/vintage`,
    },
    formal: {
      title_tag: 'Formal & Classy Save the Dates - Zola',
      meta:
        'Set the tone for your wedding day with formal and classy save the dates. Shop now with free shipping, guest addressing, and more.',
      keywords: 'formal save the dates, classy save the dates, fancy save the dates',
      canonical: `${STD_LINK}/formal`,
    },
    funny: {
      title_tag: 'Funny Wedding Save the Dates - Zola',
      meta:
        'Get your guests laughing before the big day. Shop witty and funny save the dates. Receive free shipping, guest addressing, and envelopes!',
      keywords:
        'funny save the dates, funny wedding save the dates, humorous save the dates, witty save the dates',
      canonical: `${STD_LINK}/funny`,
    },
    watercolor: {
      title_tag: 'Watercolor Save the Dates - Zola',
      meta:
        'Add an artistic touch to your wedding day. Shop watercolor save the dates with free shipping, guest addressing, envelopes, and more.',
      keywords: 'watercolor save the dates',
      canonical: `${STD_LINK}/watercolor`,
    },
    dusty_blue: {
      title_tag: 'Dusty Blue Save the Date Cards - Zola',
      meta:
        'Browse dusty blue save the dates for every budget and style. Get free shipping, guest addressing, envelopes and more!',
      keywords: 'dusty blue save the dates, dusty blue save the date cards',
      canonical: `${STD_LINK}/dusty_blue`,
    },
    royal_blue: {
      title_tag: 'Royal Blue Save the Date Cards - Zola',
      meta:
        'Set the tone for your big day with royal blue save the dates. Find designs inspired by this classic wedding color. Enjoy free shipping!',
      keywords: 'royal blue save the date, royal blue save the date cards',
      canonical: `${STD_LINK}/royal_blue`,
    },
    navy: {
      title_tag: 'Navy Blue Save the Date Cards - Zola',
      meta:
        'Navy blue save the dates are always in style. Get free shipping, guest addressing, envelopes, and more.',
      keywords: 'navy blue save the date, navy save the date, navy save the date cards',
      canonical: `${STD_LINK}/navy`,
    },
    burgundy: {
      title_tag: 'Burgundy Save the Date Cards - Zola',
      meta:
        'Announce your big day with burgundy save the dates. This rich berry hue is perfect for any celebration. Enjoy free shipping and guest addressing!',
      keywords: 'burgundy save the date, burgundy save the date cards',
      canonical: `${STD_LINK}/burgundy`,
    },
    lavender: {
      title_tag: 'Lavender Save the Date Cards - Zola',
      meta:
        'Love lavender? Shop lavender save the dates and envelopes. Get free shipping, guest addressing, envelopes, and more!',
      keywords: 'lavender save the date, lavender save the date cards',
      canonical: `${STD_LINK}/lavender`,
    },
    plum: {
      title_tag: 'Plum Save the Date Cards - Zola',
      meta:
        'Browse plum save the dates featuring this regal and elegant color. Enjoy free shipping, guest addressing, envelopes, and more.',
      keywords: 'plum save the date',
      canonical: `${STD_LINK}/plum`,
    },
    rose_gold: {
      title_tag: 'Rose Gold Save the Date Cards - Zola',
      meta:
        'Set the tone for your big day with rose gold save the dates. Find designs featuring this elegant and romantic color. Get free shipping, envelopes, and more!',
      keywords:
        'rose gold save the date, rose gold save the date cards, rose gold wedding save the date, rose save the date, rose save the date cards',
      canonical: `${STD_LINK}/rose_gold`,
    },
    dusty_rose: {
      title_tag: 'Dusty Rose Save the Date Cards - Zola',
      meta:
        'Modern and romantic, shop dusty rose save the dates for every budget and style. Get free shipping, guest addressing, envelopes, and more!',
      keywords: 'dusty rose save the date, dusty rose save the date cards',
      canonical: `${STD_LINK}/dusty_rose`,
    },
    coral: {
      title_tag: 'Coral Save the Date Cards - Zola',
      meta:
        'Browse coral save the dates for every budget and style. Get free shipping, guest addressing, envelopes, and more!',
      keywords: 'coral save the date, coral save the date cards',
      canonical: `${STD_LINK}/coral`,
    },
    peach: {
      title_tag: 'Peach Save the Date Cards - Zola',
      meta:
        'Shop classic and modern peach save the dates. Get free shipping, guest addressing, envelopes, and more!',
      keywords: 'peach save the date, peach save the date cards',
      canonical: `${STD_LINK}/peach`,
    },
    emerald_green: {
      title_tag: 'Emerald Green Save the Date Cards - Zola',
      meta:
        'Set the tone for your big day with emerald green save the dates. This rich jewel tone is perfect for any celebration. Enjoy free shipping and guest addressing!',
      keywords: 'emerald green save the date cards',
      canonical: `${STD_LINK}/emerald_green`,
    },
    teal: {
      title_tag: 'Teal Save the Date Cards - Zola',
      meta:
        'Announce your wedding day with teal save the dates. Shop now with free shipping, envelopes, guest addressing, and more.',
      keywords: 'teal save the date, teal save the date cards',
      canonical: `${STD_LINK}/teal`,
    },
    black: {
      title_tag: 'Black Save the Date Cards - Zola',
      meta:
        'Set the tone for your big day with black save the dates. Find designs featuring this elegant and bold color. Get free shipping, envelopes, and more!',
      keywords: 'black save the date, black save the date cards',
      canonical: `${STD_LINK}/black`,
    },
    blue: {
      title_tag: 'Blue Save the Date Cards - Zola',
      meta:
        'Browse blue save the dates for every budget and style. Get free shipping, guest addressing, envelopes, and more!',
      keywords: 'blue save the date, blue save the date cards',
      canonical: `${STD_LINK}/blue`,
    },
    brown: {
      title_tag: 'Brown Save the Date Cards - Zola',
      meta:
        'Shop brown save the dates, designed with rustic and modern details. Enjoy free shipping, guest addressing, and more!',
      keywords: 'brown save the date, brown save the date cards',
      canonical: `${STD_LINK}/brown`,
    },
    green: {
      title_tag: 'Green Save the Date Cards - Zola',
      meta:
        'Explore green save the dates featuring soft, modern, and earthy designs. Shop now with free shipping, guest addressing, and more.',
      keywords: 'green save the date, green save the date cards',
      canonical: `${STD_LINK}/green`,
    },
    grey: {
      title_tag: 'Grey Save the Date Cards - Zola',
      meta:
        'Shop classic and modern styles with gray save the dates. Get free shipping, guest addressing, envelopes, and more!',
      keywords: 'grey save the date, grey save the date cards',
      canonical: `${STD_LINK}/grey`,
    },
    orange: {
      title_tag: 'Orange Save the Date Cards - Zola',
      meta:
        'Browse orange save the dates for every budget and style. Get free shipping, guest addressing, envelopes, and more!',
      keywords: 'orange save the date, orange save the date cards',
      canonical: `${STD_LINK}/orange`,
    },
    pink: {
      title_tag: 'Pink Save the Date Cards - Zola',
      meta:
        'Shop pink save the dates for every budget and style. Get free shipping, guest addressing, envelopes, and more!',
      keywords: 'pink save the date, pink save the date cards',
      canonical: `${STD_LINK}/pink`,
    },
    purple: {
      title_tag: 'Purple Save the Date Cards - Zola',
      meta:
        'Purple save the dates are always in style. Shop now with free shipping, guest addressing, envelopes, and more.',
      keywords:
        'purple save the date, purple save the date cards, purple wedding save the date cards',
      canonical: `${STD_LINK}/purple`,
    },
    red: {
      title_tag: 'Red Save the Date Cards - Zola',
      meta:
        'Set the tone for your big day with red save the dates. Find designs featuring this bold and beautiful color. Get free shipping, envelopes, and more!',
      keywords: 'red save the date, red save the date cards',
      canonical: `${STD_LINK}/red`,
    },
    white: {
      title_tag: 'White Save the Date Cards - Zola',
      meta:
        'White save the dates are always in style. Shop now with free shipping, guest addressing, envelopes, and more.',
      keywords: 'white save the date, white save the date cards',
      canonical: `${STD_LINK}/white`,
    },
    yellow: {
      title_tag: 'Yellow Save the Date Cards - Zola',
      meta:
        'Announce your big day with yellow save the dates. Find designs featuring this bright and beautiful color. Get free shipping, envelopes, and more!',
      keywords: 'yellow save the date, yellow save the date cards',
      canonical: `${STD_LINK}/yellow`,
    },
  },
};

export const PARAM_CATEGORIES = [
  {
    urlKey: 'features',
    keys: ['has_foil', 'has_custom_photo', 'has_no_custom_photo', 'has_magnet'],
  },
  {
    urlKey: 'orientations',
    keys: ['is_portrait', 'is_landscape'],
  },
  {
    urlKey: 'receptionOnly',
    keys: ['is_vow_renewal'],
  },
  {
    urlKey: 'featuredArtists',
    keys: ['featured_artist'],
  },
  {
    urlKey: 'is_letterpress',
    keys: ['is_letterpress'],
  },
  {
    urlKey: 'color',
    keys: ['multiColor'],
  },
  {
    urlKey: 'sorts',
    keys: ['sorts'],
  },
];
